<script setup>
import { onMounted, onUnmounted, reactive, ref, watch } from 'vue';

// // Store management imports
import { useBreakStore } from '@/stores/break';

// // Utils imports
import { CommunicationUtil } from '@samsung360vr/overlay-app-sdk';

// // Composables
import { useAssetLoading } from '@/composables/useAssetLoading';

// // Module imports
import Branding from './FourthWallBranding.vue';
import Goods from './FourthWallGoods.vue';

const storeBreak = useBreakStore();

// // Asset loading
const { isAssetsLoaded, isTemplateReadyToFadeIn, waitForComponentAssets, templateFadeInHandler } =
  useAssetLoading(5000);
const containerRef = ref();

const isKeyCurrentlyPressed = ref(false);
const pressedKey = ref('');

let styleObjectMain;

if (storeBreak.isBreakBackgroundAnImage) {
  styleObjectMain = reactive({
    backgroundImage: `url(${storeBreak.breakBackgroundImageSrc})`,
  });
} else {
  styleObjectMain = reactive({
    background: storeBreak.breakBackgroundColor,
  });
}

// // TwoSmallProducts handler functions

const keyDownHandler = (event) => {
  CommunicationUtil.onKeyPressed(event.keyCode);
  isKeyCurrentlyPressed.value = true;
  pressedKey.value = event.key;
};

const keyUpHandler = () => {
  // console.log(`You are no longer pressing a key.`);

  isKeyCurrentlyPressed.value = false;
  pressedKey.value = '';
};

// // TwoSmallProducts functions

//

// // TwoSmallProducts lifecycle hooks

onMounted(async () => {
  document.addEventListener('keydown', keyDownHandler);
  document.addEventListener('keyup', keyUpHandler);

  // // Wait for all assets to load before showing content
  await waitForComponentAssets(containerRef.value);
  templateFadeInHandler();
});

onUnmounted(() => {
  document.removeEventListener('keydown', keyDownHandler);
  document.removeEventListener('keyup', keyUpHandler);
});

// // TwoSmallProducts watchers

watch(isKeyCurrentlyPressed, (isKeyCurrentlyPressedNewVal) => {
  if (isKeyCurrentlyPressedNewVal) {
    console.log('TwoSmallProducts – Key is pressed down');
    console.log(`pressedKey.value: ${pressedKey.value}`);
  }
});
</script>

<template>
  <section
    v-show="isAssetsLoaded"
    ref="containerRef"
    class="pitched-by-letterman"
    :class="{
      'is-clear': !isTemplateReadyToFadeIn,
      'is-opaque': isTemplateReadyToFadeIn,
    }"
    :style="styleObjectMain"
  >
    <div class="pitched-by-letterman__container">
      <Branding
        :brand-logos="storeBreak.breakSponsorLogos"
        :ad-headline="storeBreak.breakHeadlineCopy"
        :ad-headline-color="storeBreak.breakHeadlineColor"
        :ad-tagline="storeBreak.breakTaglineCopy"
        :ad-tagline-color="storeBreak.breakTaglineColor"
      />

      <div class="pitched-by-letterman__pitch pitched-by-letterman__pitch--1">
        <Goods
          :goods-data="storeBreak.breakProducts"
          :interactive-break-uuid="storeBreak.breakUuid"
          :ad-id="storeBreak.breakGeneratedIdentifier"
        />
      </div>
    </div>
  </section>
</template>
